import { useMemo, useState, useEffect, useRef, useCallback } from "react";
import Layout from "./Layout";
import FilterCasino from "./casino/FilterCasino";
import { useContextSelector } from "use-context-selector";
import AuthContext from "../context/AuthContext";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { isEmpty, lowerCase, startCase, toLower, upperCase } from "lodash";
import {
  AracadeNew,
  CarshNew,
  CasinoNew,
  FishingNew,
  LottoNew,
  SlotNew,
  TableNew,
} from "./casino/FilterList";
import CasinoSearch from "./casino/CasinoSearch";
import { t } from "i18next";
import ThemeContext from "../context/ThemeContext";
import { toast } from "react-toastify";
import { isMobile } from "react-device-detect";
import { AnimatePresence, motion } from "framer-motion";
import { useInfiniteScroll } from "../component/useInfiniteScroll";
const Casino = () => {
  const user = useContextSelector(AuthContext, (ctx) => {
    return ctx.user;
  });
  const theme = useContextSelector(ThemeContext, (ctx) => {
    return ctx.theme;
  });
  const setCasinoBefore = useContextSelector(AuthContext, (ctx) => {
    return ctx.setCasinoBefore;
  });
  const launchCasino = useContextSelector(AuthContext, (ctx) => {
    return ctx.launchCasino;
  });
  const location = useLocation();
  const [input, setInput] = useState("");
  const [list, setList] = useState([]);
  const [show, setShow] = useState(false);
  const [active, setActive] = useState("");
  const [activeInner, setActiveInner] = useState("");
  const [visibleData, setVisibleData] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const navigate = useNavigate();
  const loadingRef = useRef(false);
  const timerRef = useRef(null);
  const listRef = useRef([]);
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const type = params.get("type") || "";
    const provider = params.get("provider") || "";
    if (!isEmpty(provider)) {
      setActiveInner(provider);
    }
    if (!isEmpty(type)) {
      setActive(lowerCase(type));
    }
  }, [location.search]);

  const activeMemo = useMemo(() => {
    return active;
  }, [active]);
  const activeInnerMemo = useMemo(() => {
    return activeInner;
  }, [activeInner]);

  const object = {
    casino: CasinoNew,
    slots: SlotNew,
    table: TableNew,
    crash: CarshNew,
    fishing: FishingNew,
    arcade: AracadeNew,
    lottery: LottoNew,
  };

  useEffect(() => {
    // Cancel any pending loadMore timeout from the previous filter
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
    loadingRef.current = false;

    let result = object[activeMemo] || [];
    if (!isEmpty(activeInnerMemo) && activeInnerMemo !== "all") {
      result = result.filter(
        (res) => res?.platForm === activeInnerMemo && !isEmpty(res?.casinoType),
      );
    }
    if (!isEmpty(input)) {
      result = result.filter((res) =>
        toLower(res?.name).includes(toLower(input)),
      );
    }
    setList(result);
    listRef.current = result;
    setVisibleData(result.slice(0, 15));
    setHasMore(result.length > 15);
  }, [activeMemo, activeInnerMemo, input]);

  const loadMore = useCallback(() => {
    if (loadingRef.current) return;
    loadingRef.current = true;

    timerRef.current = setTimeout(() => {
      timerRef.current = null;
      const currentList = listRef.current;
      setVisibleData((prev) => {
        if (prev.length >= currentList.length) {
          // Already showing all data, stop loading
          setHasMore(false);
          loadingRef.current = false;
          return prev;
        }
        const nextCount = prev.length + 10;
        const nextData = currentList.slice(0, nextCount);
        if (nextData.length >= currentList.length) {
          setHasMore(false);
        }
        return nextData;
      });
      loadingRef.current = false;
    }, 300);
  }, []);
  const loaderRef = useInfiniteScroll(loadMore, hasMore);

  const handel = (res) => {
    if (!isEmpty(user)) {
      if (isEmpty(res?.platFormCode)) {
        toast.error(t("ComingSoon"));
      } else {
        if (!isEmpty(res?.gameid)) {
        } else {
          launchCasino({
            platForm: res?.platFormCode,
            gameType: res?.gameType,
            casinoType: res?.casinoType,
            isLobbyTrue: res?.isLobbyTrue,
             table: res?.tableId,
          });
        }
      }
    } else {
      setCasinoBefore(true);
    }
  };
  return (
    <Layout>
      <div className="content-main ng-star-inserted">
        <div className="content-box">
          <div className="games">
            <div className="ng-tns-c2684251700-888 ng-star-inserted">
              {isMobile && (
                <div className="search-top-block ng-tns-c2684251700-888 ng-star-inserted">
                  <div className="search-top-info ng-tns-c2684251700-888">
                    <input
                      value={input}
                      onClick={() => setShow(true)}
                      type="text"
                      className="ng-tns-c2684251700-888 ng-untouched ng-pristine ng-valid ng-star-inserted"
                      placeholder={t("SearchGames")}
                    />
                  </div>
                </div>
              )}

              {show && (
                <CasinoSearch
                  input={input}
                  setInput={setInput}
                  active={active}
                  setActive={setActive}
                  activeInner={activeInner}
                  setActiveInner={setActiveInner}
                  setShow={setShow}
                />
              )}
            </div>
            <div className="ng-tns-c3892969999-131 row-reverse ng-star-inserted">
              {" "}
              <FilterCasino
                active={active}
                setActive={setActive}
                activeInner={activeInner}
                setActiveInner={setActiveInner}
                setShow={setShow}
              />
              <div
                _ngcontent-serverapp-c3892969999
                className="sort-bar ng-tns-c3892969999-131 ng-star-inserted"
              >
                <div
                  _ngcontent-serverapp-c3892969999
                  className="sort-bar__title ng-tns-c3892969999-131"
                >
                  <span
                    style={{ color: "white" }}
                    _ngcontent-serverapp-c3892969999
                    className="ng-tns-c3892969999-131"
                  >
                    {activeInner == "all"
                      ? startCase(active)
                      : startCase(activeInner)}
                  </span>
                </div>
              </div>
            </div>
            <AnimatePresence>
              {visibleData?.length > 0 ? (
                <div className="games-main ">
                  {visibleData.map((res) => {
                    return (
                      <motion.div
                        key={res}
                        initial={{ opacity: 0, y: 40 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -20 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div
                          onClick={() => {
                            handel(res);
                          }}
                          _ngcontent-serverapp-c2986684299
                          className="games-box ng-tns-c2986684299-9 ng-trigger ng-trigger-staggerFadeAnimation"
                        >
                          <div
                            _ngcontent-serverapp-c2986684299
                            className="pic item-ani ng-tns-c2986684299-9"
                          >
                            <a
                              _ngcontent-serverapp-c2986684299
                              className="ng-tns-c2986684299-9"
                            >
                              <img
                                _ngcontent-serverapp-c2986684299
                                className="ng-tns-c2986684299-9 ng-star-inserted"
                                alt={res?.name}
                                src={res?.img}
                                loading="lazy"
                              />
                            </a>
                          </div>
                          <div
                            _ngcontent-serverapp-c2986684299
                            className="text item-ani ng-tns-c2986684299-9"
                          >
                            <h3
                              _ngcontent-serverapp-c2986684299
                              className="ng-tns-c2986684299-9"
                            >
                              {res?.name}
                            </h3>
                          </div>
                        </div>
                      </motion.div>
                    );
                  })}
                </div>
              ) : (
                <motion.div
                  initial={{ opacity: 0, y: 40 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -20 }}
                  transition={{ duration: 0.3 }}
                >
                  <div className="iplimit-card-wrap games-empty-container ng-star-inserted">
                    <div style={{ color: "white" }} className="top-inner">
                      <h3>{t("SORRY")}</h3>
                      <h4>
                        {t("SorryLow")},
                        <br />
                        {t("SorryNoGames")}
                      </h4>
                      <div className="button btn-primary">
                        <Link to="/">{t("BackButton")}</Link>
                      </div>
                    </div>
                  </div>
                </motion.div>
              )}
            </AnimatePresence>{" "}
            {hasMore && (
              <div
                ref={loaderRef}
                _ngcontent-serverapp-c302379289=""
                class="list-loading ng-star-inserted"
              />
            )}
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Casino;
